module.exports = __webpack_public_path__ + "static/media/cutsglare_portuguese_00001.aec911ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/pr/cutsglare_portuguese_00001.png
// module id = 1927
// module chunks = 0